import { getMessaging, getToken } from "firebase/messaging";
import app from "./firebaseKeys";
import { getFromStorage, setToStorage } from "../helpers";
import { STORAGE_KEYS } from "../helpers/constants/storageKeys";

const firebaseCloudMessaging = {
  // eslint-disable-next-line consistent-return
  init: async () => {
    try {
      const messaging = getMessaging(app);
      const tokenInLocalForage = await getFromStorage(STORAGE_KEYS.fcmToken);

      if (tokenInLocalForage) {
        return tokenInLocalForage;
      }

      const status = await Notification.requestPermission();
      if (status && status === "granted") {
        const fcm_token = await getToken(messaging, {
          vapidKey:
            "BCjWv1Ugsq1MQm9iyEj0tMGdKbAMh-5nVxOgN_NkMaie7eO8MPVdV3QpuPvfnRAHkMJ71bcK3uJeQwlc0Gdamvk",
        });

        if (fcm_token) {
          console.log({ "FCM ": fcm_token });
          setToStorage(STORAGE_KEYS.fcmToken, fcm_token);
          return fcm_token;
        }
      } else {
        console.log("Notification permission not granted.");
        return null;
      }
    } catch (error) {
      console.error(error);
      return null;
    }
    // }
  },
};

export { firebaseCloudMessaging };
